const { isSchoolyear } = require("@cirrus/common/constants/SecurityType")
const CustomerInfo = require("@cirrus/legacy/app-common/customer-info").default
const { clearStorageExcept } = require("@cirrus/legacy/app-common/storage-manager.es6")
const { checkStartPageAllowed, getSamlUrl } = require("@cirrus/legacy/app-common/utils/redirectSaml")

module.exports = function () {
  App.vent.on("logoff", (props) => {
    if (App.isPreview) {
      window.parent.postMessage(
        {
          type: "delivery:exit",
        },
        "*"
      )
      return
    }

    window.onbeforeunload = null

    if (isSchoolyear(props?.securityType)) {
      window.location.replace("/#/schoolyear-end")
      clearStorageExcept(["urlLang"])
      return
    }

    const exitUrls = CustomerInfo.get("exitUrls")
    const homeUrl = props?.exitUrl ? props.exitUrl : App.homeUrlKey && exitUrls ? exitUrls[App.homeUrlKey] : ""

    if (typeof homeUrl == "string" && homeUrl !== "") {
      window.location.replace(homeUrl)
      clearStorageExcept(["urlLang"])
      return
    }

    const canUseSaml = CustomerInfo.get("saml")

    if (canUseSaml && canUseSaml.enabled) {
      if (checkStartPageAllowed(canUseSaml)) {
        window.location.replace("/#saml")
      } else {
        window.location.href = getSamlUrl()
      }
    } else {
      window.location.replace("/")
    }

    clearStorageExcept(["urlLang"])
  })
  $(window).on("resize", () => {
    App.vent.trigger("window:resize")
  })

  require("./jquery-validation-localisation")()
}
